import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import Viewer from "v-viewer";

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.use(Viewer);

Vue.component("apexchart", VueApexCharts);

//var aPath = 'https://pklapi.startv.com';
var aPath = "https://accred.api.dnanetworks.in";

Vue.prototype.$apiPhotoPath = aPath;

Vue.config.productionTip = false;

var axiosInstance = axios.create({
  baseURL: aPath,
  headers: {
    //Authorization: 'Bearer ' + sessionStorage.getItem("token"),
    Appkey: "ticketgenieapikey",
  },
});
axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// axiosInstance.interceptors.response.use((response) => {
//   if(response.status === 401) {
//        alert("You are not authorized, Please login again");
//   }
//   return response;
// });

Vue.prototype.$axios = axiosInstance;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
